import { current } from "@reduxjs/toolkit";
import { isAdmin } from "src/Common/function";
import api from "./api";
import UserService from "./user.service";

//This function is for admin
const sendWOReport = (
  branchId,
  recipients,
  all,
  past7Days,
  past30Days,
  customDays,
  customStartDate,
  customEndDate,
  date,
  type
) => {
  return api.post("/api/wo/send_wo_report", {
    branchId,
    recipients,
    all,
    past7Days,
    past30Days,
    customDays,
    customStartDate,
    customEndDate,
    date,
    type,
  });
};

const sendHoursWorkedReport = (
  branchId,
  recipients,
  past7Days,
  past30Days,
  customDays,
  customStartDate,
  customEndDate,
  date
) => {
  return api.post("/api/report/send_hours_worked_report", {
    branchId,
    recipients,
    past7Days,
    past30Days,
    customDays,
    customStartDate,
    customEndDate,
    date,
  });
};

const getWOReportPreview = (
  branchId,
  all,
  past7Days,
  past30Days,
  customDays,
  customStartDate,
  customEndDate,
  date,
  type
) => {
  return api.post("/api/wo/wo_report_preview", {
    branchId,
    all,
    past7Days,
    past30Days,
    customDays,
    customStartDate,
    customEndDate,
    date,
    type,
  });
};

const getHoursWorkedReportPreview = (
  branchId,
  past7Days,
  past30Days,
  customDays,
  customStartDate,
  customEndDate,
  date
) => {
  return api.post("/api/report/hours_worked_report_preview", {
    branchId,
    past7Days,
    past30Days,
    customDays,
    customStartDate,
    customEndDate,
    date,
  });
};

const getRefrigerantReportPreview = (
  branchId,
  customerId,
  past7Days,
  past30Days,
  customDays,
  customStartDate,
  customEndDate
) => {
  return api.post("/api/report/refrigerant_report_preview", {
    branchId,
    customerId,
    past7Days,
    past30Days,
    customDays,
    customStartDate,
    customEndDate,
  });
};

const sendRefrigerantReport = (
  branchId,
  customerId,
  recipients,
  past7Days,
  past30Days,
  customDays,
  customStartDate,
  customEndDate
) => {
  return api.post("/api/report/send_refrigerant_report", {
    branchId,
    customerId,
    recipients,
    past7Days,
    past30Days,
    customDays,
    customStartDate,
    customEndDate,
  });
};

const create = (data) => {
  return api.post("/api/report/create", data);
};

const getAll = (branch) => {
  // let currentUser = UserService.getCurrentUser();
  // let branchId = branch;
  // if (!isAdmin()) {
  //   branchId = currentUser.branches[0].id;
  // }
  return api.get("/api/report/get_all", { params: { branchId: branch } });
};

const deleteReport = (id) => {
  return api.get("/api/report/delete", { params: { id } });
};

const update = (id, data) => {
  return api.post("/api/report/update", { id, data });
};

const ReportService = {
  sendWOReport,
  sendHoursWorkedReport,
  getWOReportPreview,
  getHoursWorkedReportPreview,
  getRefrigerantReportPreview,
  sendRefrigerantReport,
  create,
  getAll,
  deleteReport,
  update,
};

export default ReportService;
